import { SubAPI } from "./SubAPI";
export class Tasks2 extends SubAPI {
    listTags(input) { return this.fetcher.get("/api/task2/tags", input); }
    updateTag(input) { return this.fetcher.post("/api/task2/tag", input); }
    get(input) { return this.fetcher.get("/api/task2", input); }
    update(input) { return this.fetcher.post("/api/task2", input); }
    handleSearch(input) { return this.fetcher.get("/api/task2/handle-search", input); }
    updateComment(input) { return this.fetcher.post("/api/task2/comment", input); }
    listWatchers(input) { return this.fetcher.get("/api/task2/watchers", input); }
    updateWatchers(input) { return this.fetcher.post("/api/task2/watchers", input); }
    listAssignments(input) { return this.fetcher.get("/api/task2/assigned", input); }
    updateAssignments(input) { return this.fetcher.post("/api/task2/assigned", input); }
    myAssigned(input) { return this.fetcher.get("/api/task2/my-assigned", input); }
    getBoard(input) { return this.fetcher.get("/api/task2/board", input); }
    upsertBoard(input) { return this.fetcher.post("/api/task2/board", input); }
    getBoardColumnContent(input) { return this.fetcher.get("/api/task2/board/column-content", input); }
    updateBoardColumn(input) { return this.fetcher.post("/api/task2/board/column", input); }
    updateCardPosition(input) { return this.fetcher.post("/api/task2/board/card-position", input); }
    updateBoardWatchers(input) { return this.fetcher.post("/api/task2/board/watchers", input); }
    getBoardWatchers(input) { return this.fetcher.get("/api/task2/board/watchers", input); }
    newCardOnBoard(input) { return this.fetcher.post("/api/task2/board/new-card", input); }
    updateCard(input) { return this.fetcher.post("/api/task2/board/card", input); }
}
